import { AddressModel } from '../model';

/**
 * Formats a Singapore address based on the provided address model.
 *
 * Read {@link https://www.lingonomad.com/blogs/singapore/address-format the standard format}
 *
 * @param {AddressModel} address - The address model containing address details.
 * @returns {string} - The formatted Singapore address.
 */
export function formatSingaporeAddress(address: AddressModel): string {
  const {
    subType,
    blockNumber,
    buildingName,
    streetName,
    storey,
    unitNumber,
    country,
    postalCode,
    addressLine1,
    addressLine2,
  } = address;

  if (subType === 'FOREIGN') {
    return `${addressLine1 ?? ''}\n${addressLine2 ?? ''}\n${country?.name ?? ''} ${postalCode ?? ''}`.trim();
  }

  // If all fields are empty, return empty
  if (!postalCode && !blockNumber && !streetName && !storey && !unitNumber && !buildingName) {
    return '';
  }

  // Ground Properties
  const isLandedProperties = subType === 'LOCAL' && !blockNumber && !storey;
  if (isLandedProperties) {
    return `${blockNumber ?? ''} ${streetName ?? ''}\nSingapore ${postalCode ?? ''}`.trim();
  }

  // Building Properties
  return `${blockNumber ?? ''} ${streetName ?? ''}\n${storey && !unitNumber ? storey : ''}${
    unitNumber && storey ? `#${storey}-${unitNumber}` : ''
  } ${unitNumber && !storey ? unitNumber : ''}${buildingName ? ' ' + buildingName : ''}\nSingapore ${
    postalCode ?? ''
  }`.trim();
}
